import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { UniqueMethod } from './components/UniqueMethod';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white selection:bg-brand-orange selection:text-white overflow-x-hidden" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <OpeningHook data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <FailedSolutions data-id="element-5" />
        <UniqueMethod data-id="element-6" />
        <WhatYouGet data-id="element-7" />
        <WhoIsItFor data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <ProofSection data-id="element-10" />
        <FAQSection data-id="element-11" />
        <PricingCTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}